/**
 * Dashboard Feature Routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const dashboardRoutes: RouteRecordRaw[] = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('./views/LettagaDashboardPage.vue'),
        meta: {
            title: 'dashboard.title',
            requiresAuth: true,
            layout: 'default',
        },
    },
];
